<!-- phone-modal.component.html -->
<div class="modal-content anvt-modal">
    <div class="modal-header anvt-modal-header">
        <h3 class="modal-title">Ajouter un numéro de téléphone</h3>
        <!-- Suppression du bouton de fermeture -->
    </div>

    <div class="modal-body anvt-modal-body">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 text-center">
                    <p class="anvt-text-lead">
                        Pour utiliser votre compte sur l'application mobile, vous devez ajouter un numéro de téléphone à votre compte.
                    </p>

                    <div class="d-grid gap-3 mt-4">
                        <button
                                type="button"
                                class="btn btn-primary anvt-btn-primary"
                                (click)="redirectToPhonePage()">
                            Ajouter un numéro de téléphone
                        </button>

<!--                        <button-->
<!--                                type="button"-->
<!--                                class="btn btn-outline-secondary anvt-btn-secondary"-->
<!--                                (click)="activeModal.dismiss('Annulation')">-->
<!--                            Annuler-->
<!--                        </button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>